import { buildEmail } from '@adornis/mails/db/templates.js';
import { html } from 'lit';

export const buildNSCEmail = (contents: import('lit').TemplateResult) =>
  buildEmail({
    colorConfig: { highlight: '#f37021' },
    footer: html`<p>Your NSC SmartTeams team</p>`,
    contents,
  });
